<template>
    <section>
        <div class="spacing">

            <h2>IMS programmability using TAS</h2>
            <h3>Nokia offers powerful call management APIs</h3>

            <div class="box-holder">
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-01'" :width="100" :height="100" /></div>
                    <div class="content">Use voice call management APIs to manipulate and integrate voice services.</div>
                </div>
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-02'" :width="100" :height="100" /></div>
                    <div class="content">Deliver high-quality voice, video and messaging services across all mobile and fixed networks.</div>
                </div>
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-03'" :width="100" :height="100" /></div>
                    <div class="content">Enable people to communicate with IoT devices.</div>
                </div>
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-04'" :width="100" :height="100" /></div>
                    <div class="content">Offer flexible PBX/Enterprise connectivity and service support.</div>
                </div>
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-05'" :width="100" :height="100" /></div>
                    <div class="content">Enable people to communicate within an app and their browser.</div>
                </div>
                <div>
                    <div class="icon"><lottie :name="'chapter-1/icon-ims-via-tas-06'" :width="100" :height="100" /></div>
                    <div class="content">Enjoy the flexibility and scalability of RESTful API technology.</div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .box-holder {
        display: flex;
        flex-wrap: wrap;
        height: 520px;
        margin: 60px -20px -40px;

        > div {
            background: white;
            border-radius: 6px;
            width: calc(33.333333% - 40px);
            margin: 0 20px 40px;

            .icon {
                // background: #ededed;
                width: 80px;
                height: 80px;
                margin: 30px auto 0 auto;
            }

            .content {
                padding: 30px;
                text-align: center;
                max-width: 320px;
                margin: 0 auto;
            }
        }
    }

</style>